import { Button } from '@/components/Button';
import { Card } from '@/components/Card';
import { Text } from '@/components/Text';
import { t } from 'i18next';
import { FaPlus } from 'react-icons/fa';

export const JoinEventCallToAction = ({
  setIsModalOpen,
}: {
  setIsModalOpen: (isModalOpen: boolean) => void;
}) => {
  return (
    <Card className="flex max-w-2xl flex-col items-center gap-8 text-center">
      <div className="flex flex-col items-center gap-4">
        <h2 className="text-2xl font-semibold ">
          {t('listEvents:list.no_public_events')}
        </h2>
        <Text>{t('listEvents:list.no_public_events_description')}</Text>
      </div>
      <div className="flex flex-col items-center gap-4">
        <Text>{t('listEvents:list.private_events_description')}</Text>
        <Button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2"
        >
          <FaPlus />
          {t('listEvents:join.button')}
        </Button>
      </div>
    </Card>
  );
};
